import React, { ChangeEvent } from 'react';

import {
  CmBox,
  CmButton,
  CmCard,
  CmFormLabel,
  CmInput,
  CmModalBody,
  CmModalFooter,
  CmText,
} from '@/components/uiParts';
import { useMenuManagementDownloadBrandItems } from '@/services/BrandItem/hooks/download/useMenuManagementDownloadBrandItems';

type Props = {
  csvFile?: File;
  associateBrandId: string;
  isPreviewLoading: boolean;
  handleInputChange: (file: File) => void;
  handleClickPreview: () => void;
};

const UploadForm: React.FC<Props> = (props) => {
  const { downloadCSV, loading: loadingDownloadTemplate } =
    useMenuManagementDownloadBrandItems({
      associateBrandId: props.associateBrandId,
      onlyHeader: true,
    });

  const onInputChange = (ev: ChangeEvent<HTMLInputElement>) => {
    if (ev.target.files) {
      const file = ev.target.files[0];
      props.handleInputChange(file);
      ev.target.value = '';
    }
  };

  return (
    <>
      <CmModalBody>
        <CmCard
          height={300}
          border="none"
          backgroundColor="bgGray"
          justifyContent="center"
          alignItems="center"
        >
          {props.csvFile && (
            <CmBox marginBottom={2}>
              <CmText fontWeight="bold">
                ファイル名：{props.csvFile.name}
              </CmText>
            </CmBox>
          )}
          <CmFormLabel
            cursor="pointer"
            rounded="md"
            color="white"
            fontWeight="bold"
            backgroundColor="#394867"
            width="fit-content"
            padding="8px 18px"
          >
            <CmBox>
              {props.csvFile ? 'ファイルを選択し直す' : 'ファイルを選択'}
              <CmInput
                display="none"
                type="file"
                onChange={onInputChange}
                accept="text/csv"
              />
            </CmBox>
          </CmFormLabel>
        </CmCard>
      </CmModalBody>
      <CmModalFooter
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <CmButton
          onClick={downloadCSV}
          variant="link"
          color="#3182ce"
          fontWeight="300"
          disabled={loadingDownloadTemplate}
        >
          CSVテンプレートのダウンロード
        </CmButton>
        <CmButton
          disabled={Boolean(!props.csvFile)}
          isLoading={props.isPreviewLoading}
          onClick={props.handleClickPreview}
        >
          アップロードとプレビュー
        </CmButton>
      </CmModalFooter>
    </>
  );
};

export default UploadForm;
